import { render, staticRenderFns } from "./DropzoneFile.vue?vue&type=template&id=2c80581e&scoped=true&"
import script from "./DropzoneFile.vue?vue&type=script&lang=ts&"
export * from "./DropzoneFile.vue?vue&type=script&lang=ts&"
import style0 from "./DropzoneFile.vue?vue&type=style&index=0&id=2c80581e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c80581e",
  null
  
)

export default component.exports